import React from "react";

import MuiPopper, { PopperProps } from "@mui/material/Popper";

// MUI 5.9's generated component declaration picks DOM props removed from React 18.
// Use its exported props contract while preserving the component and forwarded ref.
const Popper = MuiPopper as React.ForwardRefExoticComponent<PopperProps & React.RefAttributes<HTMLDivElement>>;

export default Popper;
